import React from 'react';
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/outline';

const InvitationCard = ({ invitation, onAccept, onDecline }) => {
  const formatDate = (timestamp) => {
    if (!timestamp) return '';
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 sm:p-6 shadow-sm hover:shadow-md transition-shadow duration-200 mb-4">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-gray-900 mb-1">
            {invitation.organizationName || 'Organization'}
          </h3>
          <p className="text-sm text-gray-600 mb-2">
            Invited by <span className="font-medium">{invitation.inviterName || 'Someone'}</span>
          </p>
          {invitation.createdAt && (
            <p className="text-xs text-gray-500">
              {formatDate(invitation.createdAt)}
            </p>
          )}
        </div>
        
        <div className="flex gap-2 sm:flex-shrink-0">
          <button
            onClick={() => onAccept(invitation.id, invitation.organizationId)}
            className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200 text-sm font-medium"
          >
            <CheckCircleIcon className="h-5 w-5" />
            <span className="hidden sm:inline">Accept</span>
          </button>
          <button
            onClick={() => onDecline(invitation.id, invitation.organizationId)}
            className="flex items-center gap-2 px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors duration-200 text-sm font-medium"
          >
            <XCircleIcon className="h-5 w-5" />
            <span className="hidden sm:inline">Decline</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default InvitationCard;
